

<!-- <section  class="homeText"> -->
    <!-- <div class="homeText">{{text}}</div> -->
    <div fxLayout="row" fxFlex="50%" fxFlex.gt-sm="80%"  data-cy="home-intro" [innerHTML]="text"  class="homeTextTX"></div>

<!-- </section> -->